import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import MasterLayout from "../masterLayout/MasterLayout";
import { storeData, retrieveData } from "../LocalConnection/LocalConnection";
import Loader from "./Loader";
import ListingTable2 from "../components/child/ListingTable2";
import { Icon } from "@iconify/react/dist/iconify.js";
import RadarChart from "../components/child/RadarChart";
import ReactApexChart from "react-apexcharts";
const KeywordPositions = () => {
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(true);
  const [reviewsTotal, setReviewTotal] = useState([]);
  const periodSelected = retrieveData("period");

  const handleDateSelection = (start, end, period) => {
    try {
      console.log(start, end, period);
      setReviewTotal([]);
      // master_data_get(start, end, period);
    } catch (error) {
      console.error("An error occurred in handleDropdownChange:", error);
    }
  };

  useEffect(() => {
    handleDateSelection("", "", periodSelected);
    setShowLoaderAdmin(false);
  }, [periodSelected]);

  const statsData = [
    {
      title: "Keywords Tracked",
      value: "124",
      change: "+12%",
      // changeLabel: "Last 30 days users",
      changeType: "positive",
      icon: "gridicons:multiple-users",
      bgGradient: "bg-gradient-start-1",
      iconBg: "bg-cyan",
    },
    {
      title: "Visibility Score",
      value: "85%",
      change: "-5%",
      // changeLabel: "Last 30 days subscriptions",
      changeType: "negative",
      icon: "fa-solid:award",
      bgGradient: "bg-gradient-start-2",
      iconBg: "bg-purple",
    },
    {
      title: "Average Rank",
      value: "4.4",
      // change: "+200",
      changeLabel: "Across all listings",
      changeType: "positive",
      icon: "fluent:people-20-filled",
      bgGradient: "bg-gradient-start-3",
      iconBg: "bg-info",
    },
    {
      title: "Improved Keywords",
      value: "1,203",
      change: "+23",
      // changeLabel: "Last 30 days income",
      changeType: "positive",
      icon: "solar:wallet-bold",
      bgGradient: "bg-gradient-start-4",
      iconBg: "bg-success-main",
    },
  ];

  const completionData = [
    { label: "Contact Info", value: 73, icon: "mdi:card-account-details" },
    { label: "Services", value: 98, icon: "mdi:handshake" },
    { label: "Description", value: 96, icon: "mdi:text-box-outline" },
    { label: "Opening Hours", value: 99, icon: "mdi:clock-time-four" },
    { label: "Products", value: 78, icon: "mdi:package-variant" },
    { label: "Media", value: 82, icon: "mdi:image-multiple" },
    { label: "Q&A", value: 78, icon: "mdi:comment-question" },
    { label: "Posts", value: 60, icon: "mdi:post-outline" },
  ];

  // keep your original 4 colors and cycle through them
  const colors = ["orange", "success-main", "info-main", "indigo"];

  const getPillForScore = (score) => {
    if (score >= 80)
      return { text: "High", className: "bg-primary-50 text-primary-600" };
    if (score >= 60)
      return { text: "Medium", className: "bg-warning-50 text-warning-600" };
    return { text: "Low", className: "bg-error-50 text-error-600" };
  };

  const overallScore = 87;
  const overallPill = getPillForScore(overallScore);

  const doubleLineChartSeries = [
    {
      name: "Transactional",
      data: [6.2, 6.0, 5.9, 5.5, 5.9, 6.2, 6.4],
    },
    {
      name: "Navigational",
      data: [7.8, 7.5, 7.3, 7.2, 7.0, 6.8, 6.6],
    },
    {
      name: "Informational",
      data: [12.0, 11.3, 10.8, 9.8, 9.2, 8.9, 8.5],
    },
    {
      name: "Branded",
      data: [1, 1, 1, 1, 1, 1, 1],
    },
  ];

  const doubleLineChartOptions = {
    chart: {
      type: "line",
      width: "100%",
      height: 300,
      toolbar: { show: false },
    },
    // Colors close to the screenshot: blue, indigo-blue, green, orange
    colors: ["#487FFF", "#3B82F6", "#16A34A", "#F59E0B"],
    stroke: {
      curve: "smooth",
      width: 3,
      lineCap: "round",
    },
    dataLabels: { enabled: false },
    markers: {
      size: 3,
      strokeWidth: 2,
      hover: { size: 7 },
    },
    grid: {
      show: true,
      borderColor: "#D1D5DB",
      strokeDashArray: 3,
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: true } },
    },
    xaxis: {
      categories: [
        "Oct 1",
        "Oct 5",
        "Oct 10",
        "Oct 15",
        "Oct 20",
        "Oct 25",
        "Oct 30",
      ],
      tooltip: { enabled: false },
      labels: { style: { fontSize: "12px" } },
    },
    yaxis: {
      reversed: true, // 1 at top, 20 at bottom like your image
      min: 1,
      max: 20,
      tickAmount: 4,
      title: { text: "Rank" },
      labels: {
        formatter: (v) => v.toString(),
        style: { fontSize: "12px" },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: (v) => (typeof v === "number" ? v : v) },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      markers: { width: 12, height: 12, radius: 12 },
    },
  };

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {ShowLoaderAdmin && <Loader />}
        {/* Breadcrumb */}
        <Breadcrumb title="Overview" onDateSelection={handleDateSelection} />
        <div className="Over_flow_height">
          <div className="row my-4 row-cols-xxxl-5 row-cols-lg-4 row-cols-sm-2 row-cols-1 gy-4">
            {statsData.map((item, index) => (
              <div className="col" key={index}>
                <div className={`card shadow-none border ${item.bgGradient}`}>
                  <div className="card-body p-20">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                      <div>
                        <p className="fw-medium text-primary-light mb-1">
                          {item.title}
                        </p>
                        <h6 className="mb-0">{item.value}</h6>
                      </div>
                      <div
                        className={`w-50-px h-50-px ${item.iconBg} rounded-circle d-flex justify-content-center align-items-center`}
                      >
                        <Icon
                          icon={item.icon}
                          className="text-base text-2xl mb-0"
                        />
                      </div>
                    </div>

                    <p className="fw-medium text-sm text-primary-light mt-12 mb-0">
                      <span
                        className={
                          item.changeType === "positive"
                            ? "text-success-main"
                            : item.changeType === "negative"
                            ? "text-danger-main"
                            : "text-warning-main"
                        }
                      >
                        {item.change}
                      </span>{" "}
                      {item.changeLabel}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row my-4 gy-4">
            <div className="col-md-12">
              <div className="card h-100 p-0">
                <div className="card-header border-bottom bg-base py-16 px-24">
                  <h6 className="text-lg fw-semibold mb-0">
                    Keyword Ranking Trends
                  </h6>
                </div>
                <div className="card-body p-24">
                  <ReactApexChart
                    id="doubleLineChart"
                    options={doubleLineChartOptions}
                    series={doubleLineChartSeries}
                    type="line"
                    height={264}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row my-4 gy-4">
            <div className="col-xxl-12">
              <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                  <h6 className="text-lg mb-0">Button Tabs</h6>
                </div>
                <div className="card-body p-24 pt-10">
                  <ul
                    className="nav button-tab nav-pills mb-16"
                    id="pills-tab-four"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10 active"
                        id="pills-button-icon-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-button-icon-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-button-icon-home"
                        aria-selected="true"
                      >
                        <Icon
                          icon="solar:home-smile-angle-outline"
                          className="text-xl"
                        />
                        <span className="line-height-1">Home</span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                        id="pills-button-icon-details-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-button-icon-details"
                        type="button"
                        role="tab"
                        aria-controls="pills-button-icon-details"
                        aria-selected="false"
                      >
                        <Icon
                          icon="hugeicons:folder-details"
                          className="text-xl"
                        />
                        <span className="line-height-1">Details</span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                        id="pills-button-icon-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-button-icon-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-button-icon-profile"
                        aria-selected="false"
                      >
                        <Icon icon="iconamoon:profile" className="text-xl" />
                        <span className="line-height-1">Profile</span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link d-flex align-items-center gap-2 fw-semibold text-primary-light radius-4 px-16 py-10"
                        id="pills-button-icon-settings-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-button-icon-settings"
                        type="button"
                        role="tab"
                        aria-controls="pills-button-icon-settings"
                        aria-selected="false"
                      >
                        <Icon icon="uil:setting" className="text-xl" />
                        <span className="line-height-1">Settings</span>
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="pills-tab-fourContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-button-icon-home"
                      role="tabpanel"
                      aria-labelledby="pills-button-icon-home-tab"
                      tabIndex={0}
                    >
                      <ListingTable2 />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-button-icon-details"
                      role="tabpanel"
                      aria-labelledby="pills-button-icon-details-tab"
                      tabIndex={0}
                    >
                      <ListingTable2 />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-button-icon-profile"
                      role="tabpanel"
                      aria-labelledby="pills-button-icon-profile-tab"
                      tabIndex={0}
                    >
                      <ListingTable2 />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-button-icon-settings"
                      role="tabpanel"
                      aria-labelledby="pills-button-icon-settings-tab"
                      tabIndex={0}
                    >
                      <ListingTable2 />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default KeywordPositions;
